import { render } from "./BottomPanel.vue?vue&type=template&id=f6833204&scoped=true"
import script from "./BottomPanel.vue?vue&type=script&lang=js"
export * from "./BottomPanel.vue?vue&type=script&lang=js"

import "./BottomPanel.vue?vue&type=style&index=0&id=f6833204&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6833204"]])

export default __exports__